export const environment = {
  STAGE: 'DEV',
  production: false,
  projectId: 'b713a217-f664-43a7-a6f6-fad732f4daa6',
  apiBaseUrl: 'https://b713a217-f664-43a7-a6f6-fad732f4daa6.api.rappider.com',
  coreApiBaseUrl: 'https://liife-core.rapider.ai',
  verifyApiBaseUrl: 'https://liife-verify.api.rapider.ai',
  RAPIDER_AI_API_BASE_URL: 'https://api.rapider.ai',
  DESCOPE_PROJECT_ID: 'P2k10GWBu7QCAIowbm0wrqCLIVi7',
  adminTenantPublicKey: 'pk_MEgCQQDdUcV/xXro3pDkbbre+0h5gPA20/sdpIRQDh1We5XlldtGQxxXz8xwd7UYQJhrdOEnvHREdOTQUJ4dZ7qv1XRTAgMBAAE=',
  googleAuthClientID: '91185267351-ccf5ah2pc24pvcll351fh14imkjbm6cd.apps.googleusercontent.com',
  googleAuthRedirectURI: 'https://liife-dashboard.rapider.ai/auth/google',
  googleAuthScope: 'email profile https://www.googleapis.com/auth/drive',
  adminEmailDomains: ['liifeid.com'],
};